import { useRef as u, useLayoutEffect as o, useCallback as f } from "react";
function c(e) {
  const t = u(e);
  return o(() => {
    t.current = e;
  }, [e]), f((...r) => t.current(...r), []);
}
export {
  c as useCommittedCallback
};
